import {Navigate, Route, Routes} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {PlatformLoader} from '@flexinet/ui-components';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage';
import {useAllowedActions} from '../../hooks/useAllowedActions';
import config from './config';

export const ProductsLayout = () => {

    const {allowedActions, authorizing} = useAllowedActions();

    // FNP-1731: allowedActions is empty until the check settles; deciding before
    // then sends a signed-in deep link away from the page it asked for.
    if (authorizing) {
        return <PlatformLoader message={I18n.get('Checking permissions...Please wait')}/>;
    }

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListProducts')
                        ? <IndexPage/>
                        : <Navigate to='/dashboard'/>
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetProduct')
                        ? <DetailPage/>
                        : <Navigate to={config.basePath}/>
                }
            />
        </Routes>
    );
};
